import { z } from 'zod';
/**
 * x-mcp rozsireni OpenAPI operaci (07 §2/§4): trida nastroje + rezim vykonu.
 * Metadata generuji registry MCP gateway (krok 19) - zde jen jediny zdroj
 * tvaru. Gateway dedí auth/policy/audit/RLS z API; schema nastroje NIKDY
 * neobsahuje tenant_id/user_id (kontext prijde z tokenu, ne od LLM).
 */
export const MCP_TOOL_CLASSES = [
    'READ',
    'COMPUTE',
    'PREPARE',
    'WRITE_INTERNAL',
    'WRITE_EXTERNAL',
    'COMMUNICATE',
    'LEGAL',
    'MONEY',
];
export const MCP_EXECUTION_MODES = ['AUTO', 'PREPARE', 'REQUIRE_APPROVAL', 'HUMAN_ONLY'];
/**
 * Nazev nastroje `domena.akce` nebo `domena.entita.akce` (anglicky, snake_case -
 * identifikator API). Tri segmenty pribyly krokem M1: nastroje auditu se v
 * Claude jmenuji stejne jako policy akce (`dd.case.record_claim`), aby makler
 * i log videli tentyz identifikator.
 */
export const TOOL_NAME_PATTERN = /^[a-z][a-z0-9_]*(\.[a-z][a-z0-9_]*){1,2}$/;
const toolNameSchema = z.string().regex(TOOL_NAME_PATTERN, 'invalid_tool_name');
export const xMcpExtensionSchema = z.object({
    tool: toolNameSchema,
    class: z.enum(MCP_TOOL_CLASSES),
    execution: z.enum(MCP_EXECUTION_MODES),
    description: z.string().min(3).max(2000).optional(),
    /**
     * Akce z @reos/policy, kterou nastroj vyzaduje. Bez ni musi registry hadat
     * podle nazvu (registry.ts) - a co neuhadne, to `tools/list` nemuze
     * filtrovat podle role. Uvadet u kazdeho noveho nastroje.
     */
    policyAction: z.string().optional(),
});
/** Typova pomucka pro route config - chybny tvar padne uz pri kompilaci. */
export function xMcp(tool, klass, execution, description, policyAction) {
    return {
        tool: toolNameSchema.parse(tool),
        class: klass,
        execution,
        ...(description !== undefined ? { description } : {}),
        ...(policyAction !== undefined ? { policyAction } : {}),
    };
}
//# sourceMappingURL=mcp.js.map